<div class="input-group stc-input-group" *ngIf="control">
  <label *ngIf="inputName">
    {{ inputName | translate }}
    <span
      class="required-star"
      *ngIf="control.hasError('required') || control.hasError('whitespace')"
      >*</span
    >
  </label>
  <mat-form-field class="">
    <span class="input-group-text" id="basic-addon1" *ngIf="inputIcon"
      ><i class="fas {{ inputIcon }}"></i
    ></span>
    <input
      [type]="inputType"
      [id]="inputId"
      [name]="inputName"
      matInput
      [placeholder]="inputPlaceholder ? inputPlaceholder : ''"
      autocomplete="new-password"
      [formControl]="control"
      [readonly]="disabled"
      (keydown)="onKeyDown($event)"
      (input)="onInputChange($event)"
      #inputElement
    />
    @if(showPasswordIcon){
    <mat-icon
      matSuffix
      *ngIf="inputId === 'password'"
      (click)="toggelPassword()"
      ><i class="fas {{ showPassword ? ' fa-eye' : '  fa-eye-slash' }}"></i
    ></mat-icon>
    }
  </mat-form-field>
  <div class="errors" *ngIf="control.invalid && control.touched">
    <span
      *ngIf="control.hasError('required') || control.hasError('whitespace')"
    >
      {{ 'field_required' | translate }}
    </span>
    <span *ngIf="control.hasError('email')">
      {{ 'invalid_format' | translate }}
    </span>
    <span *ngIf="control.hasError('maxlength') && !selfServiceMsg">
      {{
        'Please enter text less than ' +
          control.getError('maxlength').requiredLength +
          ' character' | translate
      }}
    </span>
    <span *ngIf="control.hasError('maxlength') && selfServiceMsg">
      {{
        'Please enter text less than or equal' +
          control.getError('maxlength').requiredLength +
          ' character' | translate
      }}
    </span>
    <span *ngIf="control.hasError('max')">
      {{
        'Please enter number less than or equal ' + control.getError('max').max
          | translate
      }}
    </span>
    <span *ngIf="control.hasError('min')">
      {{
        'Please enter number greater than or equal ' +
          control.getError('min').min | translate
      }}
    </span>
    <span *ngIf="control.hasError('pattern')">
      {{ 'Please enter only numbers ' }}
    </span>
  </div>
</div>
